module.exports = __webpack_public_path__ + "img/12_23.63e31a3a.png";